'use client';

import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { NotificationListProps } from '@/src/app/components/Notification/types';
function NotificationList(t0) {
  const $ = _c(10);
  const {
    data: t1,
    children,
    className
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  const listRef = useRef(null);
  const handleScrolling = _temp;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (listRef.current) {
        handleScrolling(listRef.current);
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data) {
    t4 = [data];
    $[3] = data;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== className) {
    t5 = classNames("fixed bottom-0 w-full max-h-screen overflow-x-hidden overflow-y-auto", className);
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t5) {
    t6 = <div className={t5} aria-live="assertive" ref={listRef}>{children}</div>;
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(el) {
  el?.scrollTo(0, 0);
}
export default NotificationList;